jQuery(function ($) {
    var gemCount = 4;
    var gridSize = 6;
    var selectedRow = -1;
    var selectedCol = -1;
    var posX;
    var posY;
    var jewels = [];
    var movingItems = 0;
    var gameState = 'pick';
    var swipeStart = null;

    var variants = [
        [1, 2, 2, 3],
        [1, 2, 2, 3],
        [1, 1, 2, 2, 3],
        [3, 3, 4, 5, 8]
    ];

    var initialScore = 10000;

    var animatingScore = false;

    var level = 1;
    var score = {
        goal: initialScore,
        current: 0,
        full: 0
    };

    var timer;
    var minutes = 3;

    var paused = true;
    var gameOver = false;
    var levelUpMode = false;

    var gemSize = 100 / gridSize;

    var debugMode = false;

    // end init

    var $game_field = $('#game_field');
    var $level = $('#level');
    var $popup_level_num = $('#popup_level');
    var $time = $('#time');
    var $current_score = $('#current_score');
    var $goal_score = $('#goal_score');

    var updateTimer = function () {
        timer -= 50;

        // Every second
        if (timer >= 0 && timer % 1000 === 0) {
            $time.text(formatTime(timer));
        }

        if (score.current >= score.goal && gameState === 'pick') {
            levelUpMode = true;
            level++;
            showNextLevel();
        } else if (timer < 0 && gameState === 'pick') {
            gameOver = true;
            showGameOver();
        }
    };

    setInterval(function () {
        if (paused || gameOver || levelUpMode) {
            return;
        }
        updateTimer();
    }, 50);

    $('#start_game').on('click', function (e) {
        e.preventDefault();
        closePopups(false);
        startGame();
        updateTimer();
    });

    // level popup btn
    $('#continue_game').on('click', function (e) {
        e.preventDefault();
        closePopups(false);
        levelUpMode = false;
        startGame();
    });

    // game over popup btn
    $('.restart_game').on('click', function (e) {
        e.preventDefault();
        closePopups(false);
        startNewGame();
    });

    $('.restart_game_confirm').on('click', function (e) {
        e.preventDefault();
        openPopup('confirm-new-game');
    });

    $('.js-open-rules').on('click', function (e) {
        e.preventDefault();
        openPopup('rules-popup');
    });

    $('.back_to_game').on('click', function (e) {
        e.preventDefault();
        closePopups(true);
    });

    var focusOut = false; // set true on blur only if not paused before
    $(window).on('focus', function () {
        if (focusOut) {
            resumeGame();
        }
        focusOut = false;
    });
    $(window).on('blur', function () {
        if (!paused) {
            focusOut = true;
            pauseGame();
        } else {
            focusOut = false;
        }
    });

    function startNewGame() {
        gridSize = 6;
        level = 1;
        score.goal = initialScore;
        score.full = 0;

        startGame();
    }

    function startGame() {
        gameOver = false;
        resumeGame();

        // reset timer
        timer = minutes * 60 * 1000;
        $time.text(formatTime(timer));

        // clear field
        $game_field.html('');

        if (level === 4 || level === 8) {
            gridSize++;
        }

        gameState = 'pick';
        gemSize = 100 / gridSize;

        score.current = 0;
        score.goal = Math.round(score.goal + initialScore * (level - 1) / 2);

        animatingScore = false;

        $current_score.text('0').data('prev', 0);
        $goal_score.text(score.goal);

        $level.text(level);

        do {
            jewels = [];
            for (var i = 0; i < gridSize; i++) {
                jewels[i] = [];
                for (var j = 0; j < gridSize; j++) {
                    jewels[i][j] = -1;
                }
            }
            for (i = 0; i < gridSize; i++) {
                for (j = 0; j < gridSize; j++) {
                    do {
                        jewels[i][j] = Math.floor(Math.random() * gemCount);
                    } while (isStreak(i, j));
                    addGem(i, j);
                }
            }
        } while (!checkPossibleMove());

        //checkGameOver();
    }

    function pauseGame() {
        paused = true;
        $game_field.addClass('paused');
    }

    function resumeGame() {
        paused = false;
        $game_field.removeClass('paused');
    }

    function closePopups(resume) {
        if (resume) {
            resumeGame();
        }
        $('body').removeClass('opened-popup');
        $('.popup').removeClass('visible').addClass('hidden');
    }

    function openPopup(name) {
        pauseGame();
        $('body').addClass('opened-popup');
        $('.popup.' + name).removeClass('hidden').addClass('visible');
    }

    function showNextLevel() {
        setTimeout(function () {
            $popup_level_num.text(level);
            var $popup_level = $('#popup-box').find('.popup.next-level');
            $popup_level.find('.level-text').hide();
            if ($popup_level.find('.level-' + level + '-text').length) {
                $popup_level.find('.level-' + level + '-text').show();
            } else {
                $popup_level.find('.level-n-text').show();
            }
            openPopup('next-level');
        }, 200);
    }

    function showGameOver() {
        setTimeout(function () {
            $('#total_score_count').text(score.full);
            $('.simple-share-container').html('').append('<div class="simple-share"/>');
            $('.simple-share').simpleShare({
                providers: {
                    'odnoklassniki': {
                        name: 'odnoklassniki',
                        link: 'https://connect.ok.ru/offer?url={url}&title={title}',
                        title: textVars.okProvider,
                        width: 580,
                        height: 360
                    }
                },
                enabledProviders: ['vk', 'facebook', 'twitter', 'odnoklassniki'],
                title: textVars.shareMsg + ' ' + score.full + ' ' + numCase(score.full, textVars.scoreWord[0], textVars.scoreWord[1], textVars.scoreWord[2])
            });
            openPopup('game-over');
        }, 200);
    }

    //showGameOver();

    $game_field.swipe({
        threshold: 10,
        tap: function (event, target) {
            if ($(target).hasClass('gem')) {
                if (gameState === 'pick') {
                    var row = parseInt($(target).attr('id').split('_')[1]);
                    var col = parseInt($(target).attr('id').split('_')[2]);
                    selectedOff();
                    $(target).addClass('selected');
                    if (selectedRow === -1) {
                        selectedRow = row;
                        selectedCol = col;
                    } else {
                        if ((Math.abs(selectedRow - row) === 1 && selectedCol === col) || (Math.abs(selectedCol - col) === 1 && selectedRow === row)) {
                            selectedOff();
                            gameState = 'switch';
                            posX = col;
                            posY = row;
                            gemSwitch();
                        } else {
                            selectedRow = row;
                            selectedCol = col;
                        }
                    }
                }
            }
        },
        swipe: function (event, direction) {
            if (swipeStart != null) {
                if (gameState === 'pick') {
                    selectedRow = parseInt($(swipeStart).attr('id').split('_')[1]);
                    selectedCol = parseInt($(swipeStart).attr('id').split('_')[2]);
                    switch (direction) {
                        case 'up':
                            if (selectedRow > 0) {
                                selectedOff();
                                gameState = 'switch';
                                posX = selectedCol;
                                posY = selectedRow - 1;
                                gemSwitch();
                            }
                            break;
                        case 'down':
                            if (selectedRow < gridSize - 1) {
                                selectedOff();
                                gameState = 'switch';
                                posX = selectedCol;
                                posY = selectedRow + 1;
                                gemSwitch();
                            }
                            break;
                        case 'left':
                            if (selectedCol > 0) {
                                selectedOff();
                                gameState = 'switch';
                                posX = selectedCol - 1;
                                posY = selectedRow;
                                gemSwitch();
                            }
                            break;
                        case 'right':
                            if (selectedCol < gridSize - 1) {
                                selectedOff();
                                gameState = 'switch';
                                posX = selectedCol + 1;
                                posY = selectedRow;
                                gemSwitch();
                            }
                            break;
                    }
                }
            }
        },
        swipeStatus: function (event, phase) {
            if (phase === 'start') {
                swipeStart = null;
                if ($(event.target).hasClass('gem')) {
                    swipeStart = event.target;
                }
            }
        }
    });

    function checkMoving() {
        movingItems--;
        if (movingItems === 0) {
            //console.log(gameState);
            switch (gameState) {
                case 'revert':
                case 'switch':
                    if (!isStreak(selectedRow, selectedCol) && !isStreak(posY, posX)) {
                        if (gameState !== 'revert') {
                            gameState = 'revert';
                            gemSwitch();
                        } else {
                            gameState = 'pick';
                            selectedRow = -1;
                        }
                    } else {
                        gameState = 'remove';
                        if (isStreak(selectedRow, selectedCol)) {
                            removeGems(selectedRow, selectedCol);
                        }
                        if (isStreak(posY, posX)) {
                            removeGems(posY, posX);
                        }
                        gemFade();
                    }
                    break;
                case 'remove':
                    checkFalling();
                    break;
                case 'refill':
                    placeNewGems();
                    break;
            }
        }
        //console.log(gameState, movingItems);
    }

    function placeNewGems() {
        var gemsPlaced = 0;
        for (var i = 0; i < gridSize; i++) {
            if (jewels[0][i] === -1) {
                jewels[0][i] = Math.floor(Math.random() * gemCount);
                addGem(0, i);
                gemsPlaced++;
            }
        }
        if (gemsPlaced) {
            gameState = 'remove';
            checkFalling();
        } else {
            var combo = 0;
            for (i = 0; i < gridSize; i++) {
                for (var j = 0; j < gridSize; j++) {
                    if (j <= gridSize - 3 && jewels[i][j] === jewels[i][j + 1] && jewels[i][j] === jewels[i][j + 2]) {
                        combo++;
                        removeGems(i, j);
                    }
                    if (i <= gridSize - 3 && jewels[i][j] === jewels[i + 1][j] && jewels[i][j] === jewels[i + 2][j]) {
                        combo++;
                        removeGems(i, j);
                    }
                }
            }
            if (combo > 0) {
                gameState = 'remove';
                gemFade();
            } else {
                gameState = 'pick';
                selectedRow = -1;
                checkGameOver();
            }
        }
    }

    function checkFalling() {
        var fellDown = 0;
        for (var j = 0; j < gridSize; j++) {
            for (var i = gridSize - 1; i > 0; i--) {
                if (jewels[i][j] === -1 && jewels[i - 1][j] >= 0) {
                    $gem((i - 1), j).addClass('fall').attr('id', gemId(i, j));
                    jewels[i][j] = jewels[i - 1][j];
                    jewels[i - 1][j] = -1;
                    fellDown++;
                }
            }
        }
        $.each($('.fall'), function () {
            movingItems++;
            $(this).animate({
                top: '+=' + gemSize + '%'
            }, {
                duration: 100,
                complete: function () {
                    $(this).removeClass('fall');
                    checkMoving();
                }
            });
        });
        if (fellDown === 0) {
            gameState = 'refill';
            movingItems = 1;
            checkMoving();
        }
    }

    function gemFade() {
        increaseScore();
        setTimeout(function () {
            $.each($('.remove'), function () {
                movingItems++;
                $(this).animate({
                    opacity: 0
                }, {
                    duration: 200,
                    complete: function () {
                        $(this).remove();
                        checkMoving();
                    }
                });
            });
        }, 200);
    }

    function gemSwitch() {
        var yOffset = selectedRow - posY;
        var xOffset = selectedCol - posX;
        $gem(selectedRow, selectedCol).addClass('switch').attr('dir', '-1');
        $gem(posY, posX).addClass('switch').attr('dir', '1');
        $.each($('.switch'), function () {
            movingItems++;
            $(this).animate({
                left: '+=' + (xOffset * gemSize * $(this).attr('dir')) + '%',
                top: '+=' + (yOffset * gemSize * $(this).attr('dir')) + '%'
            }, {
                duration: 250,
                complete: function () {
                    checkMoving();
                }
            }).removeClass('switch')
        });
        $gem(selectedRow, selectedCol).attr('id', 'temp');
        $gem(posY, posX).attr('id', gemId(selectedRow, selectedCol));
        $('#temp').attr('id', gemId(posY, posX));
        var temp = jewels[selectedRow][selectedCol];
        jewels[selectedRow][selectedCol] = jewels[posY][posX];
        jewels[posY][posX] = temp;
    }

    function removeGems(row, col) {
        var gemValue = jewels[row][col];
        var tmp = row;
        var destroyedGems = 1;
        $gem(row, col).addClass('remove');
        if (isVerticalStreak(row, col)) {
            while (tmp > 0 && jewels[tmp - 1][col] === gemValue) {
                $gem((tmp - 1), col).addClass('remove');
                destroyedGems++;
                jewels[tmp - 1][col] = -1;
                tmp--;
            }
            tmp = row;
            while (tmp < gridSize - 1 && jewels[tmp + 1][col] === gemValue) {
                $gem((tmp + 1), col).addClass('remove');
                destroyedGems++;
                jewels[tmp + 1][col] = -1;
                tmp++;
            }
        }
        if (isHorizontalStreak(row, col)) {
            tmp = col;
            while (tmp > 0 && jewels[row][tmp - 1] === gemValue) {
                $gem(row, (tmp - 1)).addClass('remove');
                destroyedGems++;
                jewels[row][tmp - 1] = -1;
                tmp--;
            }
            tmp = col;
            while (tmp < gridSize - 1 && jewels[row][tmp + 1] === gemValue) {
                $gem(row, (tmp + 1)).addClass('remove');
                destroyedGems++;
                jewels[row][tmp + 1] = -1;
                tmp++;
            }
        }
        jewels[row][col] = -1;

        // add points
        var perGem = 100,
            gain = destroyedGems * perGem;

        // For a streak bigger than 3, the player gets a bonus
        if (destroyedGems > 3) {
            for (var i = 0; i < destroyedGems - 3; i++) {
                gain += 200 * (i + 1);
            }
        }

        score.current += gain;
        score.full += gain;
    }

    function isVerticalStreak(row, col) {
        var gemValue = jewels[row][col];
        var streak = 0;
        var tmp = row;
        while (tmp > 0 && jewels[tmp - 1][col] === gemValue) {
            streak++;
            tmp--;
        }
        tmp = row;
        while (tmp < gridSize - 1 && jewels[tmp + 1][col] === gemValue) {
            streak++;
            tmp++;
        }
        return streak > 1
    }

    function isHorizontalStreak(row, col) {
        var gemValue = jewels[row][col];
        var streak = 0;
        var tmp = col;
        while (tmp > 0 && jewels[row][tmp - 1] === gemValue) {
            streak++;
            tmp--;
        }
        tmp = col;
        while (tmp < gridSize - 1 && jewels[row][tmp + 1] === gemValue) {
            streak++;
            tmp++;
        }
        return streak > 1
    }

    function isStreak(row, col) {
        return isVerticalStreak(row, col) || isHorizontalStreak(row, col);
    }

    // custom

    function checkGameOver() {
        setTimeout(function () {
            if (!checkPossibleMove()) {
                gameOver = true;
                showGameOver();
            }
        }, 100);
    }

    function checkPossibleMove() {
        for (var i = 0; i < gridSize; i++) {
            for (var j = 0; j < gridSize; j++) {
                // move top
                if (i > 0) {
                    if (checkTwoSwapped(i, j, i - 1, j)) {
                        return ['top', i, j];
                    }
                }
                // move bottom
                if (i < gridSize - 1) {
                    if (checkTwoSwapped(i, j, i + 1, j)) {
                        return ['bottom', i, j];
                    }
                }
                // move left
                if (j > 0) {
                    if (checkTwoSwapped(i, j, i, j - 1)) {
                        return ['left', i, j];
                    }
                }
                // move right
                if (j < gridSize - 1) {
                    if (checkTwoSwapped(i, j, i, j + 1)) {
                        return ['right', i, j];
                    }
                }
            }
        }
        return false;
    }

    function checkTwoSwapped(row1, col1, row2, col2) {
        var v1 = jewels[row1][col1];
        var v2 = jewels[row2][col2];
        jewels[row2][col2] = v1;
        jewels[row1][col1] = v2;
        var res = (isStreak(row1, col1) || isStreak(row2, col2));
        jewels[row2][col2] = v2;
        jewels[row1][col1] = v1;
        return res;
    }

    function gemId(row, col) {
        return 'gem_' + row + '_' + col;
    }

    function $gem(row, col) {
        return $('#' + gemId(row, col));
    }

    function addGem(row, col) {
        $game_field.append('<div id="' + gemId(row, col) + '"></div>');
        var type = jewels[row][col],
            typeMaxLevel = Math.min(level, variants[type].length),
            variant = Math.floor(Math.random() * variants[type][typeMaxLevel - 1]);
        $gem(row, col).css({
            top: (row * gemSize) + '%',
            left: (col * gemSize) + '%',
            width: gemSize + '%',
            height: gemSize + '%'
        }).addClass('gem type' + type + ' variant' + variant + ' ready');
        if (debugMode) {
            $gem(row, col).addClass('gem-simple');
        }
    }

    function selectedOff() {
        $('.gem').removeClass('selected');
    }

    function formatTime(ms) {
        var sec = Math.floor(ms / 1000);
        var min = Math.floor(sec / 60);
        sec = sec % 60;
        return '' + (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
    }

    function increaseScore() {
        animatingScore = false;
        if ($(window).width() < 1000) {
            $current_score.text(score.current);
        } else {
            var prev = $current_score.data('prev');
            $current_score.data('prev', score.current);
            animatingScore = true;
            animateIncreaseScore(prev, score.current, Math.ceil((score.current - prev) / 20));
        }
    }

    function animateIncreaseScore(value, to, range) {
        if (animatingScore) {
            if (value >= to) {
                value = to;
                animatingScore = false;
            }
            $current_score.text(value);
            if (animatingScore) {
                setTimeout(function () {
                    animateIncreaseScore(value + range, to, range);
                }, 10);
            }
        } else {
            $current_score.text(to);
        }
    }

    function numCase(num, one, two, five) {
        var text = '';
        if (num > 100) {
            num = num % 100;
        }
        if (num >= 5 && num <= 20) {
            text = five;
        } else {
            var ost = num % 10;
            if (ost === 1) {
                text = one;
            } else if (ost > 1 && ost < 5) {
                text = two;
            } else {
                text = five;
            }
        }
        return text;
    }
});
